<template>
  <el-dialog
    class="previewDialogBox"
    :visible.sync="dialogVisible"
    width="860px"
    :append-to-body="true"
    :show-close="false"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :custom-class="'previewDialogContainer'"
    :destroy-on-close="true"
  >
    <div class="title">
      <div>
        <span class="title-h3">预览</span>
        <span class="title-desc"
          >左右滑动可查看{{titleTxt}}前后效果对比图</span
        >
      </div>
      <i class="el-icon-close closeIcon" @click="handleClose"></i>
    </div>
    <div
      id="cover"
      onpaste="return false"
      oncontextmenu="return false"
      oncopy="return false"
      oncut="return false"
      class="cover"
    >
      <div class="cover-main compress">
        <span class="cd-image-label" style="left: 16px">{{beforeTxt}}</span>
        <span class="cd-image-label" style="right: 16px">{{afterTxt}}</span>
        <div
          class="image-container"
          style="position: relative"
          :class="{
            imageContainer: true,
            scaleHeight:
              currentFileInfo?.origin?.width >= currentFileInfo?.origin?.height
          }"
        >
          <div class="figureBox" :style="{ width: position + 'px' }">
            <div class="imgBox">
              <img
                :draggable="false"
                :src="currentFileInfo?.origin?.src"
                alt=""
                class="nowImg"
              />
            </div>
          </div>
          <div v-if="isShowWatermark" class="waterMarkBox" :style="{width: ratioSize(currentFileInfo?.target?.width, currentFileInfo?.target?.height).ratioWidth + 'px',
              height: ratioSize(currentFileInfo?.target?.width, currentFileInfo?.target?.height).ratioHeight + 'px'}">
          </div>

            <img
              :draggable="false"
              :src="currentFileInfo?.target?.src"
              alt=""
              class="originImg"
              :style="{width: currentFileInfo?.target?.width + 'px',
              height: currentFileInfo?.target?.height + 'px'}"
            />
          <div class="moveBtn" :style="{ left: position + 'px' }">
            <div class="move" @mousedown="figureMouseDown"></div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
// import addWatermarkToImage from "@/utils/addWatermarkToImage";

import { mapGetters } from "vuex";

export default {
  name: 'PreviewModal',
  components: {},
  props: {
    fileInfo: Object,
    dialogVisible: {
      type: Boolean,
      default: false
    },
    molti: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dragging: false,
      position: `calc(50% - 20px)`,
      currentFileInfo: {},
    }
  },
  watch: {
    fileInfo: {
      handler(val) {
        this.currentFileInfo = val
        // if (this.$route.meta.handlingMethod === 'losslessAmplification' || this.$route.meta.handlingMethod === 'clearnessAamplification') {
        //   let src =  await addWatermarkToImage(val?.target?.raw, '下载后无水印')
        //   if (this.currentFileInfo?.target?.src) {
        //     this.currentFileInfo.target.src = src
        //   }
        // }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters(['isVip', "isLogin"]),
    userIsVip() {
      return this.isVip
    },
    userIsLogin() {
      return this.isLogin
    },
    beforeWidth() {
      return this.position
    },
    titleTxt() {
      let arr1 = ['losslessAmplification', 'clearnessAamplification', 'upcolor']
      let arr2 = ['laozhaopian']
      let arr3 = ['edit', 'changeDpi', 'increaseMemory']
      const handlingMethod = this.$route.meta.handlingMethod
      if (arr1.includes(handlingMethod)) {
        return '处理'
      } else if (arr2.includes(handlingMethod)) {
        return '修复'
      } else if (arr3.includes(handlingMethod)) {
        return '修改'
      } else {
        return '压缩'
      }
    },
    beforeTxt() {
      const handlingMethod = this.$route.meta.handlingMethod
      let arr1 = ['losslessAmplification', 'clearnessAamplification']
      let arr2 = ['laozhaopian']
      let arr3 = ['upcolor']
      let arr4 = ['edit', 'changeDpi', 'increaseMemory']

      if (arr1.includes(handlingMethod)) {
        return `原图 ${this.currentFileInfo?.origin?.width} X ${this.currentFileInfo?.origin?.height}`
      } else if (arr2.includes(handlingMethod)) {
        return `修复前 ${this.currentFileInfo?.origin?.size}KB`
      } else if (arr3.includes(handlingMethod)) {
        return `上色前${this.currentFileInfo?.origin?.size}KB`
      } else if (arr4.includes(handlingMethod)) {
        return `修改前${this.currentFileInfo?.origin?.size}KB`
      } else {
        return `压缩前 ${this.currentFileInfo?.origin?.size}KB`
      }
    },
    afterTxt() {
      const handlingMethod = this.$route.meta.handlingMethod
      let arr1 = ['losslessAmplification', 'clearnessAamplification']
      let arr2 = ['laozhaopian']
      let arr3 = ['upcolor']
      let arr4 = ['edit', 'changeDpi', 'increaseMemory']
      if (arr1.includes(handlingMethod)) {
        return `${this.molti === '0' ? '1' : this.molti}X | ${this.currentFileInfo?.target?.width} X ${this.currentFileInfo?.target?.height}`
      } else if (arr2.includes(handlingMethod)) {
        return `修复后 ${this.currentFileInfo?.target?.size}KB`
      } else if (arr3.includes(handlingMethod)) {
        return `上色后${this.currentFileInfo?.target?.size}KB`
      } else if (arr4.includes(handlingMethod)) {
        return `修改后${this.currentFileInfo?.target?.size}KB`
      } else {
        return `压缩后 ${this.currentFileInfo?.target?.size}KB`
      }
    },
    isShowWatermark() {
      const writeRouter = ['compress', 'compress-jpg', 'compress-bmp', 'compress-png', 'compress-webp', 'compress-size', 'compress-zjz']
      return (!this.isLogin || !this.isVip) && !writeRouter.includes(this.$route.name)
    }
  },
  methods: {

    ratioSize(width, height) {
      let ratioWidth = width, ratioHeight = height;
      if (height > width) {
        if (height > 800) {
          ratioHeight = 800
          ratioWidth = ratioHeight / (height / width)

        }
      } else {
        if (width > 860) {
          ratioWidth = 860
          ratioHeight = (height / width) * ratioWidth
        }
      }


      return {
        ratioWidth,
        ratioHeight
      }
    },

    handleClose() {
      this.dragging = false
      this.position = `calc(50% - 20px`
      this.$emit('onClose')
    },
    figureMouseDown(event) {
      this.dragging = true
      const clientX = event.clientX || event.touches[0].clientX

      const container = this.$el.querySelector('.imageContainer')
      const containerLeft = container.getBoundingClientRect().left
      const figureBox = this.$el.querySelector('.move')
      const figureBoxWidth = figureBox.clientWidth + 2 // 2是因为 border宽度

      const newPosition = clientX - containerLeft

      this.position = Math.max(
        figureBoxWidth / 2,
        Math.min(container.offsetWidth - figureBoxWidth / 2, newPosition)
      )

      document.addEventListener('mousemove', this.drag)
      document.addEventListener('touchmove', this.drag, { passive: false })
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchend', this.stopDrag)
    },
    drag(event) {
      if (this.dragging) {
        const clientX = event.clientX || event.touches[0].clientX
        const container = this.$el.querySelector('.imageContainer')
        const containerLeft = container.getBoundingClientRect().left
        const figureBox = this.$el.querySelector('.move')
        const figureBoxWidth = figureBox.clientWidth + 2
        const newPosition = clientX - containerLeft
        this.position = Math.max(
          figureBoxWidth / 2,
          Math.min(container.offsetWidth - figureBoxWidth / 2, newPosition)
        )
      }
    },
    stopDrag() {
      this.dragging = false
      document.removeEventListener('mousemove', this.drag)
      document.removeEventListener('touchmove', this.drag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchend', this.stopDrag)
    }
  },
  created() {}
}
</script>
<style scoped lang="less">
@import url('./index.less');
</style>
